<script>
import { mapActions } from 'vuex';

import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';

import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportContacts',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: 'Search for Contact',
      storeNS: 'contactSearch',
      contacts: [],
    };
  },
  methods: {
    ...mapActions(['loadFilteredContacts']),

    updateSearch(val) {
      this.searchContacts(val);
      this.$emit('updateSearch', val);
    },

    searchContacts: debounce(function (search) {
      this.loadFilteredContacts({
        filters: {
          fields: ['first_name', 'last_name'],
          limit: 10,
          name: search,
        },
      }).then(({ results }) => {
        this.contacts = results;
      });
    }, 300),

    isContactAlreadyExistsExists(contactId) {
      return this.contacts.some((contact) => contact.con_id === contactId);
    },

    loadSelectedContacts() {
      if (isEmpty(this.value)) return;

      const selectedContacts = Array.isArray(this.value)
        ? this.value
        : [this.value];

      selectedContacts.forEach(async (value) => {
        if (!this.isContactAlreadyExistsExists(value)) {
          const res = await this.loadFilteredContacts({
            filters: {
              id: value,
            },
          });

          if (res.results.length) {
            this.contacts.push(res.results[0]);
          }
        }
      });
    },
  },
  computed: {
    getOptions() {
      return this.contacts.map((contact) => {
        return {
          label: this.getContactName(contact),
          value: contact.con_id,
        };
      });
    },
  },
  mounted() {
    this.loadSelectedContacts();
  },
};
</script>
